import { useState, useEffect } from "react";

const AnimateTyping = ({ oldText, newText, delay, setDoneAnimating, usePreWrapper = true }) => {
  const [currentText, setCurrentText] = useState(oldText);
  const [currentIdx, setCurrentIdx] = useState(oldText.length);
  const [isDeleting, setIsDeleting] = useState(true);

  useEffect(() => {
    const updateText = () => {
      setCurrentIdx((prevIdx) => {
        return isDeleting ? prevIdx - 1 : prevIdx + 1;
      });
      setCurrentText((prevText) => {
        return isDeleting ? prevText.slice(0, prevText.length - 1) : prevText + newText[currentIdx];
      });
    };

    if (isDeleting) {
      if (currentIdx === 0) {
        setIsDeleting(false);
      } else {
        const timeout = setTimeout(updateText, delay);
        return () => clearTimeout(timeout);
      }
    } else {
      if (currentIdx < newText.length) {
        const timeout = setTimeout(updateText, delay);
        return () => clearTimeout(timeout);
      } else {
        setDoneAnimating(true);
      }
    }
  }, [currentIdx, delay, newText, isDeleting]);

  return usePreWrapper ? <pre>{currentText}</pre> : <>{currentText}</>;
};

export { AnimateTyping };
